export default __webpack_public_path__ + "static/media/044-piano.6264b4e1.svg";